// extracted by mini-css-extract-plugin
module.exports = {"root":"textarea_root__KKSYx","error":"textarea_error__K1sGN"};